'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;
function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    throw new TypeError('This library (validator.js) validates strings only');
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/vux/~/validator/lib/util/assertString.js
// module id = 97
// module chunks = 47